import noAvatar from "../../../assets/images/no-avatar.png"

export const DEFAULT_AVATAR_IMAGE = noAvatar;